import React, { useContext } from 'react';
import { Button } from '@flatfy/supernova-new';
import PropTypes from 'prop-types';
import FiltersIcon from '../../icons/filters.svg';
import {
  FlatsFiltersOpenedContext,
  FlatsFiltersContentContext,
} from '../../FlatsFilters/FlatsFiltersContext';
import { attachGaDataAttributes } from '../../helpers/analytics';

const PlansTrigger = ({ setTriggerEl }) => {
  const body = document.querySelector('body');
  const [opened, setOpened] = useContext(FlatsFiltersOpenedContext);
  const { activeFiltersCount } = useContext(FlatsFiltersContentContext);
  const handleClick = () => {
    body.classList.toggle('UIPopup-no-scroll');
    setOpened(!opened);
  };

  return (
    <Button
      variant="secondary-outline"
      onClick={handleClick}
      leftIcon={<FiltersIcon />}
      ref={setTriggerEl}
      classes={{
        root: 'PlansFilter-trigger',
        leftIcon: 'PlansFilter-trigger-icon',
      }}
      {...attachGaDataAttributes({
        category: window.eventCategory,
        action: 'filters',
        label: 'open_click',
      })}
    >
      {activeFiltersCount !== 0 && <span>{activeFiltersCount}</span>}
    </Button>
  );
};

PlansTrigger.propTypes = {
  setTriggerEl: PropTypes.func,
};

export default PlansTrigger;
